<template>
  <div>
    <div class="row mt-5">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-5">
                <h4 class="card-title">{{ hotelSelected }} - Quartos</h4>
                <span v-if="metricMode === 'room'" class="badge badge-soft-info font-size-13 mb-2" style="font-weight: 400; white-space: nowrap;text-overflow: ellipsis;max-width: 260px;overflow: hidden; font-weight: 500;">{{ roomsOccupiedTotal ? roomsOccupiedTotal : 'Nenhum' }} {{ roomsOccupiedTotal === 1 ? 'quarto ocupado' : 'quartos ocupados' }} </span>
                <span v-else class="badge badge-soft-info font-size-13 mb-2" style="font-weight: 400; white-space: nowrap;text-overflow: ellipsis;max-width: 260px;overflow: hidden; font-weight: 500;">{{ allocated ? allocated : 'Nenhum' }} {{ allocated > 1 ? 'participantes alocados' : 'participante alocado' }} </span>
              </div>
              <div class="col-sm-7">
                <div class="float-sm-end d-flex">
                  <div class="text-sm-right me-2 mr-2">
                    <b-dropdown
                      size="md"
                      variant="light"
                      class="m-0 rounded-drop">
                      <template v-slot:button-content >
                        {{ hotelSelected }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <span>
                        <b-dropdown-item-button
                          @click="toggleHotel('')"
                        >
                          Todos os Hotéis
                        </b-dropdown-item-button>
                        <b-dropdown-item-button
                          v-for="(s,idx) in listHotels"
                          :key="idx"
                          @click="toggleHotel(s.id)"
                        >
                          {{ s.name }}
                        </b-dropdown-item-button>
                      </span>
                    </b-dropdown>
                  </div>
                  <div class="text-sm-right me-2 mr-2" v-if="periodOptions.length">
                    <select v-model="selectedPeriod" class="form-control rl-period" @change="onPeriodChange">
                      <option :value="null">Todos os períodos</option>
                      <option v-for="p in periodOptions" :key="p.key" :value="p.key">{{ p.label }}</option>
                    </select>
                  </div>
                  <div class="text-sm-right me-2 mr-2 rl-cat-wrap" v-if="categoryOptions.length">
                    <multiselect
                      v-model="selectedCategories"
                      :options="categoryOptions"
                      :multiple="true"
                      label="label"
                      track-by="id"
                      placeholder="Todas as categorias"
                      select-label=""
                      deselect-label="Remover"
                      selected-label="Selecionada"
                      :close-on-select="false"
                      :limit="1"
                      :limit-text="rcLimitText"
                      @input="onCategoryChange"
                    ></multiselect>
                  </div>
                  <div class="text-sm-right me-2 mr-2">
                    <button
                      type="button"
                      class="btn rl-metric-toggle"
                      :class="metricMode === 'room' ? 'active' : ''"
                      @click="toggleMetricMode"
                      :title="metricMode === 'room' ? 'Métrica por quarto — clique para ver por pessoa' : 'Métrica por pessoa — clique para ver por quarto'"
                    >
                      <i class="bx" :class="metricMode === 'room' ? 'bx-bed' : 'bx-user'"></i>
                      <span class="rl-metric-toggle-label">{{ metricMode === 'room' ? 'Por quarto' : 'Por pessoa' }}</span>
                    </button>
                  </div>
                  <div class="text-sm-right">
                    <b-dropdown size="md" variant="primary" class="m-0 rounded-drop">
                      <template v-slot:button-content>
                        <i class="mdi mdi-export mr-1"></i>
                        Exportar
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item-button @click="exportRooms('simple')">
                        Simples
                      </b-dropdown-item-button>
                      <b-dropdown-item-button @click="exportRooms('grouped')">
                        Agrupado
                      </b-dropdown-item-button>
                      <b-dropdown-divider />
                      <b-dropdown-item-button @click="exportRooms('rooming-list')">
                        RL Previsível
                      </b-dropdown-item-button>
                    </b-dropdown>
                  </div>
                </div>
              </div>
              <!-- end col-->
            </div>

            <!-- Mini-cards de ocupação por tipo (também filtram a lista) -->
            <div class="row mb-2" v-if="typeMetrics.length">
              <div class="col-12">
                <div class="type-cards">
                  <div
                    v-for="m in typeMetrics"
                    :key="m.type_room"
                    class="type-card"
                    :class="{ active: selectedType === m.type_room }"
                    @click="toggleType(m.type_room)"
                  >
                    <div class="type-card-top">
                      <span class="type-card-label">{{ m.type_room }}</span>
                      <span class="type-card-badge" :class="{ full: free(m) <= 0 }">
                        {{ free(m) }} {{ free(m) === 1 ? 'livre' : 'livres' }}
                      </span>
                    </div>
                    <div class="type-card-value">
                      {{ metricValue(m) }}<span class="type-card-cap">/{{ metricTotal(m) }}</span>
                    </div>
                    <div class="type-card-bar">
                      <div class="type-card-bar-fill" :style="{ width: barWidth(m) }"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="categories.length > 0 && params.hotel_id">
              <div class="col-12 mb-2">
                <!-- Chips de categoria: atalhos sincronizados com o multi-select acima
                     (clicar alterna a categoria dentro da seleção) -->
                <div id="btn-radios-1" role="group" tabindex="-1" class="flex justify-start btn-group-toggle gap-1">
                  <label class="btn" :class="{ 'btn-primary': !selectedCategoryIds.length, 'btn-light': selectedCategoryIds.length }">
                    <input id="category-all" type="checkbox" class="" @click="toggleCategory('')"><span>Todos</span>
                  </label>
                  <label class="btn" :class="{ 'btn-primary': selectedCategoryIds.includes(category.id), 'btn-light': !selectedCategoryIds.includes(category.id) }" v-for="(category, i) in categories" :key="i">
                    <input :id="category.name" type="checkbox" class="" @click="toggleCategory(category.id)"><span>{{ category.name }} ({{ category.rooms }})</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="search-box mb-2">
                  <div class="position-relative">
                    <input type="text" class="form-control" v-model="search" placeholder="Buscar por participante, gênero, hotel, categoria de quarto ou tipo de acomodação..." @keyup.enter="doSearch"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <th width="5%">#</th>
                    <th width="25%">Hotel</th>
                    <th width="20%">Acomodação</th>
                    <th width="10%">Capacidade</th>
                    <th width="30%">Ocupantes</th>
                    <th width="10%">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in rooms" :key="list.id" class="text-muted">
                    <td >
                      {{ list.id }}
                    </td>
                    <td>{{ list.hotel.data.name }}</td>
                    <td style="font-size: 12px !important;">
                      <span class="text-muted" style="font-weight: 600;">{{ list.category.data.name }}</span><br />
                      <span class="badge badge-soft-secondary font-size-12">{{ list.type_room_label }}</span>
                    </td>
                    <td style="font-size: 12px !important;">{{ list.allocations + '/' +list.capacity }}</td>
                    <td style="font-size: 12px !important;">
                      <div class="tag-container">
                        <div class="tag" v-for="(allocation, index) in list.allocation.data" :key="index">
                          <span class="name link" alt="Ficha do participante" title="Ficha do participante" @click="showParticipant(allocation.participant_id)">{{ allocation.participant.data.name }}</span>
                          <span v-if="canManageHousing" class="remove" alt="Remover alocação" title="Remover alocação" @click="removeAllocation(allocation.participant_id)">×</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span class="badge font-size-12 p-1" style="min-width:100px" :class="{
                        'badge-soft-success': `${parseInt(list.status)}` === '1',
                        'badge-soft-danger': `${parseInt(list.status)}` === '0',
                      }"><i class="bx bxs-circle"></i> {{ statusLabel[list.status] }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-participant v-model="formParticipant" ref="formParticipant"></modal-participant>
    <export-modal ref="exportModal" title="Exportar Alocados" />
  </div>
</template>
<script>
import appConfig from '@/app.config'
import Multiselect from 'vue-multiselect'
import { mapActions, mapState, mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import http from '@/http'
import ModalParticipant from '@/pages/participants/Form'
import ExportModal from '@/components/modals/ExportModal'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import serviceReport from './services'
import { EventBus } from '@/eventBus'

export default {
  components: {
    Multiselect,
    ModalParticipant,
    ExportModal
  },
  name: 'rooms-hotel',
  page: {
    title: 'Gestão de Hospedagem',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      timeout: 60000,
      search: '',
      listHotels: [],
      statusLabel: ['Ocupado', 'Disponível'],
      params: {
        hotel_id: null,
        category_id: null
      },
      typeMetrics: [],
      allCategories: [],
      selectedCategories: [],
      metricMode: 'person', // 'person' (padrão) | 'room'
      selectedType: null,
      selectedPeriod: null,
      hotelFilter: null,
      formParticipant: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      hotelId: null,
      idParticipant: null,
      allocated: null,
      submitted: false,
      title: 'Gestão de Hospedagem'
    }
  },
  created () {
    EventBus.$on('allocationAdded', (action) => {
      if (action) {
        this.updateList()
        this.loadTypeMetrics(this.hotelFilter)
      }
    })
    EventBus.$on('roomAdded', (action) => {
      if (action) {
        this.updateList()
        this.loadTypeMetrics(this.hotelFilter)
      }
    })
  },
  mounted () {
    this.updateList()
    this.getHotels()
    this.getAllCategories()
    this.getParticipantsAllocated()
    this.loadTypeMetrics(null)
    this.totalRows = this.pagination.total
    this.currentPage = this.pagination.current_page
    this.loading = false
  },
  beforeDestroy () {
    this.cancelAutoUpdate()
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('hotel', ['hotels']),
    ...mapState('hotelCategory', ['categories']),
    ...mapState('room', ['rooms', 'pagination']),
    ...mapGetters('auth', ['hasPermission', 'isSuperAdmin']),
    rows () {
      return this.pagination.total
    },
    roomsOccupiedTotal () {
      return this.typeMetrics.reduce((s, m) => s + (m.rooms_occupied || 0), 0)
    },
    canManageHousing () {
      return this.isSuperAdmin || this.hasPermission('housing.manage')
    },
    hotelSelected () {
      if (this.listHotels.length > 0 && this.params.hotel_id) {
        let hotel = this.listHotels.filter(h => h.id === this.params.hotel_id)[0]
        return hotel ? hotel.name : ''
      }
      return 'Todos os Hotéis'
    },
    periodOptions () {
      const fmt = (d) => d ? this.$moment(d).format('DD/MM/YYYY') : ''
      // Fonte: hotel específico (seus períodos) ou todos os hotéis
      const source = this.params.hotel_id
        ? [this.listHotels.find(h => h.id === this.params.hotel_id) || {}]
        : this.listHotels
      // Dedupe por datas (só o range de datas no rótulo)
      const seen = {}
      const opts = []
      source.forEach(h => {
        (h.date_ranges || []).forEach(r => {
          const key = `${r.check_in}|${r.check_out}`
          if (!seen[key]) {
            seen[key] = true
            opts.push({ key, check_in: r.check_in, check_out: r.check_out, label: `${fmt(r.check_in)} – ${fmt(r.check_out)}` })
          }
        })
      })
      return opts.sort((a, b) => (a.check_in > b.check_in ? 1 : -1))
    },
    selectedCategoryIds () {
      return this.selectedCategories.map(c => c.id)
    },
    // Opções do dropdown de categoria: com hotel selecionado usa as categorias
    // dele (com contagem de quartos, como os radios); sem hotel, todas do evento.
    categoryOptions () {
      if (this.params.hotel_id && this.categories.length) {
        return this.categories.map(c => ({ id: c.id, label: c.rooms != null ? `${c.name} (${c.rooms})` : c.name }))
      }
      return this.allCategories
    }
  },
  methods: {
    ...mapActions('hotel', {
      getListHotels: 'listHotels'
    }),
    ...mapActions('hotelCategory', {
      getListCaregories: 'getAll'
    }),
    ...mapActions('room', {
      getRooms: 'getAll'
    }),
    ...mapActions('hotelAllocation', {
      removeUserAllocation: 'deleteAllocation'
    }),
    showParticipant (participantId) {
      this.$refs.formParticipant.open(participantId)
      this.formParticipant = true
    },
    exportRooms (type) {
      // O RL Previsível é do evento inteiro (escopo = bloco de convidados),
      // então não leva os filtros da tela — só o tipo.
      if (type === 'rooming-list') {
        this.$refs.exportModal.start(() => serviceReport.exportRooms({ type }))
        return
      }
      this.params.type = type
      this.$refs.exportModal.start(() => serviceReport.exportRooms(this.params))
    },
    removeAllocation (participantId) {
      Swal.fire({
        title: 'Você tem certeza ?',
        text: 'Essa ação não poderá ser revertida',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, REMOVER ALOCAÇÃO!'
      }).then(result => {
        if (result.value) {
          try {
            this.removeUserAllocation(participantId).then((res) => {
              successMessage('Sucesso: Participante removido do quarto com sucesso.', 2500)
              this.updateList()
              this.loadTypeMetrics(this.hotelFilter)
              EventBus.$emit('allocationRemoved', 1)
            }).catch((err) => {
              errorMessage('Alerta: ' + err.message)
            })
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    getParticipantsAllocated () {
      let params = {
        hotel_id: this.params.hotel_id || null,
        category_id: this.params.category_id || null
      }
      http.get(`/admin/metrics/participantsAllocated`, { params }).then((response) => {
        this.allocated = response.data
      }).catch((error) => {
        console.error(error)
      })
    },
    periodRange () {
      if (!this.selectedPeriod) return { start: null, end: null }
      const parts = this.selectedPeriod.split('|')
      return { start: parts[0] || null, end: parts[1] || null }
    },
    loadTypeMetrics (hotelId) {
      const p = this.periodRange()
      serviceReport.roomsMetrics({
        hotel_id: hotelId || null,
        category_id: this.params.category_id || null,
        range_start: p.start,
        range_end: p.end
      }).then((res) => {
        this.typeMetrics = res || []
      }).catch(() => {
        this.typeMetrics = []
      })
    },
    onPeriodChange () {
      this.loadTypeMetrics(this.hotelFilter)
      this.updateList()
    },
    toggleType (type) {
      this.selectedType = this.selectedType === type ? null : type
      this.updateList()
    },
    // Valor ocupado/total conforme o modo da métrica (pessoa x quarto).
    metricValue (m) {
      return this.metricMode === 'room' ? (m.rooms_occupied || 0) : (m.allocated || 0)
    },
    metricTotal (m) {
      return this.metricMode === 'room' ? (m.rooms || 0) : (m.capacity || 0)
    },
    toggleMetricMode () {
      this.metricMode = this.metricMode === 'room' ? 'person' : 'room'
    },
    barWidth (m) {
      const total = this.metricTotal(m)
      const pct = total ? Math.min(100, Math.round((this.metricValue(m) / total) * 100)) : 0
      return pct + '%'
    },
    free (m) {
      return Math.max(0, this.metricTotal(m) - this.metricValue(m))
    },
    cancelAutoUpdate () {
      clearInterval(this.timeout)
    },
    showFilters () {
      this.$refs.modalFilter.open()
    },
    toggleHotel (hotelId) {
      this.params.hotel_id = hotelId
      this.hotelFilter = hotelId || null
      this.selectedType = null
      this.selectedPeriod = null
      // Categoria selecionada pertence ao contexto anterior — reseta na troca
      this.params.category_id = null
      this.selectedCategories = []
      if (hotelId) {
        this.getCategories()
      }
      this.getParticipantsAllocated()
      this.loadTypeMetrics(this.hotelFilter)
      this.updateList()
    },
    toggleCategory (categoryId) {
      // Chip "Todos" limpa; chip de categoria alterna dentro da seleção múltipla
      if (!categoryId) {
        this.selectedCategories = []
      } else if (this.selectedCategoryIds.includes(categoryId)) {
        this.selectedCategories = this.selectedCategories.filter(c => c.id !== categoryId)
      } else {
        const opt = this.categoryOptions.find(c => c.id === categoryId)
        if (opt) this.selectedCategories = [...this.selectedCategories, opt]
      }
      this.onCategoryChange()
    },
    rcLimitText (count) {
      return `+${count}`
    },
    onCategoryChange () {
      // Array de ids (multi-select) ou null = todas — backend aceita os dois
      this.params.category_id = this.selectedCategoryIds.length ? this.selectedCategoryIds : null
      this.updateList()
      this.getParticipantsAllocated()
      this.loadTypeMetrics(this.hotelFilter)
    },
    getAllCategories () {
      http.get('/admin/hotels/categories/select').then((res) => {
        this.allCategories = Object.entries(res.data || {}).map(([id, name]) => ({ id: Number(id), label: name }))
      }).catch(() => {
        this.allCategories = []
      })
    },
    getCategories () {
      let params = {
        hotel_id: this.params.hotel_id || null,
        search: null,
        limit: 100,
        page: 1
      }
      this.params = params
      this.getListCaregories(this.params).then((res) => {
      }).catch(error => {
        console.log(error)
      })
    },
    getHotels () {
      let params = {}
      this.params = params
      this.getListHotels(this.params).then((res) => {
        this.listHotels = res
        // this.participants = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    getReport (filter) {
      console.log(filter)
      let params = {
        include: 'category,hotel,allocation.participant',
        hotel_id: filter.hotel_id || null,
        category_id: filter.category_id || null,
        type_room: this.selectedType || null,
        range_start: this.periodRange().start,
        range_end: this.periodRange().end,
        search: this.search || null,
        tag: filter.tag || null,
        distinct: filter.distinct || null,
        limit: this.perPage,
        page: this.currentPage,
        checkin_date: filter.checkin_date ? this.$moment(filter.checkin_date).format('YYYY-MM-DD') : null
      }
      this.params = params
      let loeader = this.$loading.show()
      this.getRooms(this.params).then((res) => {
        // this.participants = res.data
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    doSearch () {
      this.params = { ...this.params, search: this.search }
      this.getReport(this.params)
    },
    updateList () {
      this.getReport(this.params)
      // this.$refs.child.getSubscribers()
    }
  },
  watch: {
    // currentPage () { this.updateList() }
    // total () { this.updateList() },
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.inativado { background: #f7ebeb }

/* Mini-cards de ocupação por tipo (carrossel horizontal) */
.type-cards {
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  overflow-x: auto;
  padding: 2px 2px 8px;
  scrollbar-width: thin;
  scrollbar-color: #d0d5dd transparent;
}
.type-cards::-webkit-scrollbar { height: 6px; }
.type-cards::-webkit-scrollbar-track { background: transparent; }
.type-cards::-webkit-scrollbar-thumb { background-color: #d0d5dd; border-radius: 3px; }
.type-cards::-webkit-scrollbar-thumb:hover { background-color: #b0b5bd; }
.type-card {
  flex: 0 0 auto;
  width: 185px;
  background: #fff;
  border: 1px solid #eef0f4;
  border-radius: 5px;
  padding: 14px 16px 12px;
  cursor: pointer;
  transition: box-shadow .15s ease, border-color .15s ease;
}
.type-card:hover {
  border-color: #d1d5db;
  box-shadow: 0 2px 12px rgba(0, 0, 0, .06);
}
.type-card.active {
  border-color: #556ee6;
  box-shadow: 0 0 0 1px #556ee6;
}
.type-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 8px;
}
.type-card-badge {
  flex: 0 0 auto;
  font-size: 10px;
  font-weight: 700;
  color: #0b7a4b;
  background: rgba(52, 195, 143, .14);
  border-radius: 20px;
  padding: 2px 8px;
  white-space: nowrap;
}
.type-card-badge.full {
  color: #b42318;
  background: rgba(244, 106, 106, .14);
}
.type-card-label {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 12px;
  font-weight: 500;
  color: #5b6478;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.type-card-value {
  font-size: 24px;
  font-weight: 800;
  color: #1a1d26;
  letter-spacing: -.5px;
  line-height: 1.2;
}
.type-card-cap {
  font-size: 14px;
  font-weight: 500;
  color: #97a0af;
}
.type-card-bar {
  height: 4px;
  border-radius: 2px;
  background: #f1f3f6;
  overflow: hidden;
  margin-top: 10px;
}
.type-card-bar-fill {
  height: 100%;
  border-radius: 2px;
  background: #556ee6;
  transition: width .6s ease;
}
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { max-height: 530px;}
.float-sm-end { float: right }
.rl-period { min-width: 200px; max-width: 280px; }
.rl-cat-wrap { min-width: 220px; max-width: 300px; text-align: left; }
/* Multi-select compacto: 1 linha fixa (1 chip + "+N"), tipografia igual aos
   demais filtros da toolbar (form-control: 13px / #495057) */
.rl-cat-wrap ::v-deep .multiselect { font-size: 13px; min-height: 38px; }
.rl-cat-wrap ::v-deep .multiselect__tags {
  min-height: 38px !important;
  max-height: 38px;
  overflow: hidden;
  white-space: nowrap;
  padding: 6px 40px 0 8px !important;
  font-size: 13px;
  border-color: #ced4da;
  border-radius: 4px;
}
.rl-cat-wrap ::v-deep .multiselect__tags-wrap { display: inline-flex; align-items: center; max-width: 100%; }
.rl-cat-wrap ::v-deep .multiselect__tag {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0;
  vertical-align: middle;
}
.rl-cat-wrap ::v-deep .multiselect__strong {
  display: inline-block;
  margin-bottom: 0;
  padding: 2px 6px;
  border-radius: 5px;
  background: #eef1fb;
  color: #556ee6;
  font-size: 12px;
  font-weight: 600;
  vertical-align: middle;
}
.rl-cat-wrap ::v-deep .multiselect__placeholder {
  color: #495057;
  font-size: 13px;
  margin-bottom: 0;
  padding-top: 2px;
}
.rl-cat-wrap ::v-deep .multiselect__input { font-size: 13px; }
.rl-cat-wrap ::v-deep .multiselect__select { height: 36px; }
/* Toggle da métrica de ocupação (por pessoa x por quarto) */
.rl-metric-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 100%;
  border: 1px solid #ced4da;
  background: #fff;
  color: #5b6478;
  font-weight: 500;
  border-radius: 6px;
  transition: all .15s ease;
  white-space: nowrap;
}
.rl-metric-toggle:hover {
  border-color: #556ee6;
  color: #556ee6;
}
.rl-metric-toggle .bx { font-size: 16px; line-height: 1; }
.rl-metric-toggle.active {
  background: #556ee6;
  border-color: #556ee6;
  color: #fff;
  box-shadow: 0 0 0 1px #556ee6;
}
.rl-metric-toggle.active:hover { color: #fff; }
.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding: 5px;
}
.tag {
  display: flex;
  align-items: center;
  background-color: #e9ecef;
  border-radius: 4px;
  padding: 0px 8px;
  font-size: 12px;
  color: #484e53;
}
.tag .name {
  margin-right: 10px;
  padding: 4px;
}
.tag .name:hover {
  color: #2149cd;
}
.tag .remove {
  cursor: pointer;
  color: #868e96;
  font-weight: bold;
  font-size: 14px;
  border-left: 1px solid #aeb2b6;
  padding-left: 5px;
}
.tag .remove:hover {
  color: #dc3545;
}
</style>
